module.exports = __webpack_public_path__ + "static/media/Terms_Geek.11adf02a.jpg";